import { render, staticRenderFns } from "./ManageLayout.vue?vue&type=template&id=7952f79a&lang=pug&"
import script from "./ManageLayout.vue?vue&type=script&lang=ts&"
export * from "./ManageLayout.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports